export default "__VITE_ASSET__YQ1w2IAc__"